import React from 'react';
import axios from 'axios';
import { Form, Input, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';
import stickyError from 'components/stickyError';

import globalFormItemLayout from 'components/Portal/formItemLayout'; 
const formItemLayout = Object.assign({}, globalFormItemLayout, {labelCol: {sm: {span: 8}}, wrapperCol: {sm: {span: 16}}});

class SSN extends React.Component {
	state = {
		SSN: null
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((errors, values) => {
			if (errors) {
				const firstErrorMessage = errors[Object.keys(errors)[0]].errors[0].message;
				stickyError('Validation error: ' + firstErrorMessage, 4.5);
				this.props.isSubmitted();
			}
			else {
				axios.put(apiPath+'/folio/nid', {
					nid: values.SSN.split('-').join('')
				}, {withCredentials: true}).then(result => {
					message.success('Saved!');
					this.props.form.setFieldsValue({ SSN: result.data });
				}).catch(this.props.handleAxiosSaveError).then(result => {
					this.props.isSubmitted();
				});
			}
		});
	}
	getSSN = () => {
		this.props.isLoading();
		return axios.get(apiPath+'/folio/nid', {withCredentials: true}).then(result => {
			this.setState({ SSN: result.data });
		}).catch(this.props.handleAxiosLoadError).then(result => {
			this.props.isDoneLoading();
		});
	}
	componentDidMount() { this.getSSN(); }
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'personal/SSN');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'personal/SSN');
			if (redirect) return redirect;
		}

		const { getFieldDecorator } = this.props.form;
		return (
			<Form onSubmit={this.handleSubmit}>
				<legend>SSN is required for US Citizens</legend>
				<Form.Item label="Social Security Number" {...formItemLayout}>
					{getFieldDecorator('SSN', {
						initialValue: this.state.SSN,
						rules: [
							{required: true, len: 9},
							{message: 'SSN must be made up of numbers', transform: (value) => parseInt(value, 10), type: 'integer'}
						]
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.props.getStatus().submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(SSN));



// WEBPACK FOOTER //
// ./portal-components/Portal/Personal/SSN.jsx